
import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Tab } from '@process-advisor/process-miner/navigation/sidebar/tabs/tab';
import { SidebarTab, SidebarTabs } from '@process-advisor/process-miner/shared/consts';

const Wrapper = styled.div`
    position: absolute;
    transform-origin: top right;
    display: flex;
    flex-direction: column;
    right: 0;
`;

type Props = {
    activeTab: SidebarTab,
    onChange: (activeTab: SidebarTab) => void,
    initialLoad: boolean,
    mode: string
}

export const Tabs: React.FC<Props> = ({ activeTab, onChange, initialLoad, mode}) => (

    <Wrapper>
        {initialLoad ? '' :
            _.map(
                (tab: SidebarTab) => (
                    <Tab
                        key={tab}
                        onClick={onChange}
                        tab={tab}
                        mode={mode}
                        visible={ true }
                        activeTab={activeTab} />
                    )
                    
            )(SidebarTabs)
        }
    </Wrapper>
);
